var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UButtonGroupItem.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-512937b0\",\"hasScoped\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UButtonGroupItem.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/_default/components/Uloc/button/UButtonGroupItem.vue
// module id = 531
// module chunks = 2